import crmMessages from 'src/utils/crmMessages';

const viewMode = 'viewMode';
const width = '450';
const height = '458';

export default {
  set(mode) {
    localStorage.setItem(viewMode, mode);
    if (mode === 'MINI') {
      crmMessages.sendViewModeMsg(mode, width, height);
    } else {
      crmMessages.sendViewModeMsg(mode);
    }
  },
  current() {
    return localStorage.getItem(viewMode);
  },
  remove() {
    localStorage.removeItem(viewMode);
  },
};
